import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AddScanICourrier } from 'src/app/shared/models/iCourrier/scans/add-scan-icourrier';
import { AttachScanToExistingMailComponentParams } from 'src/app/shared/models/iCourrier/scans/attach-scan-to-mail';
import { ScanFromCourrier, ScanFromCourrierPaginate } from 'src/app/shared/models/iCourrier/scans/scan-from-courrier';
import { ToBeCompletedFromScan } from 'src/app/shared/models/iCourrier/scans/to-be-completed-from-scan';
import { MailWithFilesCreatedDTO, MailCreatedACompleter } from '../interfaces';
import { MailCreateScanLotFullParams } from 'src/app/shared/models/iCourrier/scans/mail-create-scan-lot-full';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ICourrierScanService {
  private apiGatewayBaseUrl: string;

  constructor(private http: HttpClient) {
    const config = environment;
    this.apiGatewayBaseUrl = config.apiICourrierBaseUrl;
  }

  public getScanLots(params?: { [key: string]: string | number | number[] }): Observable<ScanFromCourrierPaginate> {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach((key) => {
        httpParams = httpParams.set(key, params[key].toString());
      });
    }
    return this.http.get(`${this.apiGatewayBaseUrl}/ScanLots/Search`, { params: httpParams }).pipe(
      map((res: ScanFromCourrierPaginate) => {
        return res;
      })
    );
  }

  public updateStatusScan(data: { lotGuids: string[]; status: string }): Observable<ScanFromCourrier> {
    return this.http.put(`${this.apiGatewayBaseUrl}/ScanLots/Status`, data).pipe(
      map((res: ScanFromCourrier) => {
        return res;
      })
    );
  }

  public createScan(data: AddScanICourrier): Observable<ScanFromCourrier> {
    return this.http.post(`${this.apiGatewayBaseUrl}/ScanLots`, data).pipe(
      map((res: ScanFromCourrier) => {
        return res;
      })
    );
  }

  public deleteScan(lotGuids: string[]): Observable<boolean> {
    return this.http.delete<boolean>(`${this.apiGatewayBaseUrl}/ScanLots`, { params: { lotGuids: lotGuids.join(',') } }).pipe(
      map((res: boolean) => {
        return res;
      })
    );
  }

  public attachScanToMail(scanLotCompleted: boolean, data: AttachScanToExistingMailComponentParams) {
    return this.http.put(`${this.apiGatewayBaseUrl}/ScanLots/AttachToMail?scanLotCompleted=${scanLotCompleted}`, data);
  }

  public massAttachScanToMail(scanLotCompleted: boolean, data: AttachScanToExistingMailComponentParams[]) {
    return this.http.put(`${this.apiGatewayBaseUrl}/ScanLots/MassAttachToMail?scanLotCompleted=${scanLotCompleted}`, data);
  }

  public aCompleterFromScan(data: ToBeCompletedFromScan): Observable<MailCreatedACompleter[]> {
    return this.http.post<MailCreatedACompleter[]>(`${this.apiGatewayBaseUrl}/Mails/ACompleterFromScan`, data);
  }

  public createCompleteMailFromiScan(mail: MailCreateScanLotFullParams): Observable<MailWithFilesCreatedDTO> {
    return this.http.post<MailWithFilesCreatedDTO>(`${this.apiGatewayBaseUrl}/Mails/FullFromScan?skipWarns=true`, mail);
  }
}
